import Box from '@mui/material/Box'
import ButtonMobileComponent from 'components/button-mobile'
import TagComponent from 'components/tag'
import { useEffect, useState } from 'react'
import { UpdateSchoolInputProps } from 'types/SchoolTypes'
import SettingsBox from './SettingsBox'

interface ActivitiesSettingsProps {
  initialSchoolActivities: string[]
  onSave: (body: UpdateSchoolInputProps, loadingMsg?: string, cb?: () => void) => Promise<void>
}

function ActivitiesSettings({ initialSchoolActivities, onSave }: ActivitiesSettingsProps) {
  const [schoolActivities, setSchoolActivities] = useState<string[]>(initialSchoolActivities?.sort() ?? [])

  // Sync local state with props when props change
  useEffect(() => {
    setSchoolActivities([...(initialSchoolActivities ?? [])].sort())
  }, [initialSchoolActivities])

  // hasChanges is always derived
  /* eslint @typescript-eslint/no-var-requires: "off" */
  const isEqual = require('lodash.isequal')
  const hasChanges = !isEqual(schoolActivities, (initialSchoolActivities ?? []).sort())

  const handleSave = async () => {
    if (hasChanges) {
      await onSave({ schoolActivities }, 'Updating school activities...')
    }
  }

  return (
    <SettingsBox
      title='After School Activities'
      subtitle='Admins curate activities. Families select activities. We connect families with matching activities.'
    >
      <TagComponent
        placeholder='Enter a new activity and press Enter'
        helperText='Select from the listed activities or create your own by typing and pressing Enter'
        options={initialSchoolActivities?.sort() ?? []}
        selected={schoolActivities ?? []}
        allowMultiple={true}
        allowNew={true}
        newPrefix={`Create this activity: `}
        onChange={(va: any) => setSchoolActivities([...(va ?? [])])}
      />
      {hasChanges && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <ButtonMobileComponent text='Save' width='w-[100px]' onClick={handleSave} />
        </Box>
      )}
    </SettingsBox>
  )
}

export default ActivitiesSettings
